import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { InputSchema } from "@redotech/ui/form";
import { memo, useState } from "react";
import { DynamicRatePricingRulesModal } from "./dynamic-rate-pricing-rules-modal";
import { dynamicRatePricingSettingsForm } from "./dynamic-rate-pricing-settings-form";

interface DynamicRatePricingSettingsCardProps {
  input: InputSchema.Input<typeof dynamicRatePricingSettingsForm>;
  canEditSpreadRanges: boolean;
}

export const DynamicRatePricingSettingsCard = memo(
  function DynamicRatePricingSettingsCard({
    input,
    canEditSpreadRanges,
  }: DynamicRatePricingSettingsCardProps) {
    const [rulesOpen, setRulesOpen] = useState(false);
    const { enabled } = input.inputs;
    const disabled = !enabled.value || !canEditSpreadRanges;

    return (
      <Card title="Dynamic Rate Pricing" w="full">
        <Flex dir="column" gap="md">
          <RedoToggle
            disabled={!canEditSpreadRanges}
            label="Enable dynamic rate pricing"
            setValue={enabled.setValue}
            size="sm"
            value={enabled.value}
          />
          <Text fontSize="sm" textColor="secondary">
            Lower configured services to beat the cheapest available benchmark.
            Prices stay unchanged if the benchmark cannot be beaten without
            going below provider cost.
          </Text>
          <RedoButton
            disabled={disabled}
            hierarchy="secondary"
            onClick={() => setRulesOpen(true)}
            size="sm"
            text="Manage service mappings"
          />
          {input.errors.length > 0 && (
            <Text fontSize="sm" textColor="error">
              {input.errors.join(". ")}
            </Text>
          )}
        </Flex>
        <DynamicRatePricingRulesModal
          disabled={disabled}
          input={input}
          isOpen={rulesOpen}
          onClose={() => setRulesOpen(false)}
        />
      </Card>
    );
  },
);
